<template>
<div>
  <div class="modal fade" data-backdrop="static" id="modal-einvoice">
        <div class="modal-dialog custom_modal">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title">{{$t('invoice.einvoice.title')}}</h1>
              </div>
              <div class="modal-body">
                <b-form>
                  <!-- Row 1 -->
                  <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.bill_code')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.bill_code')"
                              class = "form-control"
                              v-model="einvoice_data.bill_code"
                              disabled
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.description')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.description')"
                              class = "form-control"
                              v-model="einvoice_data.description"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.apartment_code')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.apartment_code')"
                              class = "form-control"
                              v-model="einvoice_data.apartment_code"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Row 2 -->
                  <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.measure')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.measure')"
                              class = "form-control"
                              v-model="einvoice_data.measure"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.quantity')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.quantity')"
                              class = "form-control"
                              v-model="einvoice_data.quantity"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.unit_price')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.unit_price')"
                              class = "form-control"
                              v-model="einvoice_data.unit_price"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Row 3 -->
                  <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.vat')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.vat')"
                              class = "form-control"
                              v-model="einvoice_data.vat"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.record_date')">
                        <div class="form-group">
                          <div>
                            <!--input
                              :placeholder="$t('invoice.einvoice.record_date')"
                              class = "form-control"
                              v-model="einvoice_data.record_date"
                            >-->
                            <date-picker :placeholder="$t('invoice.einvoice.record_date')" v-model="einvoice_data.record_date" :config="options"></date-picker>
                          </div>
                        </div>
                      </b-form-group>
                    </div>

                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.buying_person')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.buying_person')"
                              class = "form-control"
                              v-model="einvoice_data.buying_person"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Row 4 -->
                  <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.company')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.company')"
                              class = "form-control"
                              v-model="einvoice_data.company"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.tax_code')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.tax_code')"
                              class = "form-control"
                              v-model="einvoice_data.tax_code"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.address')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.address')"
                              class = "form-control"
                              v-model="einvoice_data.address"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Row 5 -->
                  <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.account')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.account')"
                              class = "form-control"
                              v-model="einvoice_data.account"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.method')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.method')"
                              class = "form-control"
                              v-model="einvoice_data.method"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.invoice_code')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.invoice_code')"
                              class = "form-control"
                              v-model="einvoice_data.invoice_code"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Row 6 -->
                  <div class="row">

                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.email_receive')">
                        <div class="form-group" style="margin-bottom: 5px;">
                          <div>
                            <!--<input
                              :placeholder="$t('invoice.einvoice.email_receive')"
                              class = "form-control"
                              v-model="einvoice_data.email_receive"
                            >-->
                            <input
                              class="col-lg-1 col-md-4 col-sm-4 control-label"
                              type="checkbox"
                              v-model="einvoice_data.email_receive"
                              :checked="einvoice_data.email_receive"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.print_receive')">
                        <div class="form-group" style="margin-bottom: 5px;">
                          <div>
                            <!--<input
                              :placeholder="$t('invoice.einvoice.print_receive')"
                              class = "form-control"
                              v-model="einvoice_data.print_receive"
                            >-->
                            <input
                              class="col-lg-1 col-md-4 col-sm-4 control-label"
                              type="checkbox"
                              v-model="einvoice_data.print_receive"
                              :checked="einvoice_data.print_receive"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.sms_receive')">
                        <div class="form-group" style="margin-bottom: 5px;">
                          <div>
                            <!--<input
                              :placeholder="$t('invoice.einvoice.sms_receive')"
                              class = "form-control"
                              v-model="einvoice_data.sms_receive"
                            >-->
                            <input
                              class="col-lg-1 col-md-4 col-sm-4 control-label"
                              type="checkbox"
                              v-model="einvoice_data.sms_receive"
                              :checked="einvoice_data.sms_receive"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Row 7 -->
                  <div class="row">

                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.dss_ms')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.dss_ms')"
                              class = "form-control"
                              v-model="einvoice_data.dss_ms"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.dse_email')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.dse_email')"
                              class = "form-control"
                              v-model="einvoice_data.dse_email"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.name_receive')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.name_receive')"
                              class = "form-control"
                              v-model="einvoice_data.name_receive"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Row 8 -->
                  <div class="row">

                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.name_receive_phone')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.name_receive_phone')"
                              class = "form-control"
                              v-model="einvoice_data.name_receive_phone"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.house_no')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.house_no')"
                              class = "form-control"
                              v-model="einvoice_data.house_no"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.city')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.city')"
                              class = "form-control"
                              v-model="einvoice_data.city"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Row 9 -->
                  <div class="row">

                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('invoice.einvoice.district')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.district')"
                              class = "form-control"
                              v-model="einvoice_data.district"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.commune')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('invoice.einvoice.commune')"
                              class = "form-control"
                              v-model="einvoice_data.commune"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>

                  <!-- Booking other details -->
                  <b-form-group label-size="sm" label-for="input-sm"  :label="$t('invoice.einvoice.other_details')">
                    <div class="form-group">
                      <div>
                        <textarea v-model="einvoice_data.other_details" :placeholder="$t('invoice.einvoice.other_details')" class="md-textarea form-control" rows="3"></textarea>
                      </div>
                    </div>
                  </b-form-group>
                </b-form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class='btn btn-success btn-sm pull-right'
                  @click="updateEinvoiceBkav"
                >{{$t('common.save')}}</button>
                <button
                  type="button"
                  class='btn btn-warning btn-sm pull-left'
                  @click="closeModal"
                >{{$t('common.back')}}</button>
              </div>
            </div>
            <!-- /.modal-content -->
        </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'

export default {
  name: 'lte-modal-einvoice',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
        options: {
            format: "DD-MM-YYYY",
            useCurrent: false
        },
        einvoice_data: {
          "bill_code":null,
          "description": null,//Thu tiền điện từ 26/08/2019 đến 25/09/2019 căn A05.02
          "apartment_code":null,
          "measure": null,
          "quantity": 0,
          "unit_price": 0,
          "vat": 0,
          "record_date": moment(new Date()).format("DD-MM-YYYY"),
          "buying_person": null,
          "company": null,
          "tax_code": 0,
          "address": null,
          "account": null,
          "method": null,
          "invoice_code": null,
          "email_receive": true,
          "dse_email": null,
          "sms_receive": false,
          "dss_ms": null,
          "print_receive": false,
          "name_receive": null,
          "name_receive_phone": null,
          "house_no": null,
          "city": null,
          "district": null,
          "commune": null,
          "other_details": null,
          "id":0
        }
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    closeModal: function() {
        $("#modal-einvoice").modal("hide");
        this.disabledCheckin = true
    },
    resetData: function() {
      this.einvoice_data.bill_code = null;
      this.einvoice_data.description = null;
      this.einvoice_data.apartment_code = null;
      this.einvoice_data.measure = null;
      this.einvoice_data.quantity = 0;
      this.einvoice_data.unit_price = 0;
      this.einvoice_data.vat = 0;
      this.einvoice_data.record_date = moment(new Date()).format("DD-MM-YYYY");
      this.einvoice_data.buying_person = null;
      this.einvoice_data.company = null;
      this.einvoice_data.tax_code = 0;
      this.einvoice_data.address = null;
      this.einvoice_data.account = null;
      this.einvoice_data.method = null;
      this.einvoice_data.invoice_code = null;
      this.einvoice_data.email_receive = true;
      this.einvoice_data.dse_email = null;
      this.einvoice_data.sms_receive = false;
      this.einvoice_data.dss_ms = null;
      this.einvoice_data.print_receive = false;
      this.einvoice_data.name_receive_phone = null;
      this.einvoice_data.house_no = null;
      this.einvoice_data.city = null;
      this.einvoice_data.district = null;
      this.einvoice_data.commune = null;
      this.einvoice_data.other_details = null;
      this.einvoice_data.is_create = null;
    },
    updateInfoEinvoiceBkav: function() {
      this.resetData();
      $("#modal-einvoice").modal("show");
      this.einvoice_data.bill_code = "ASEI" + moment(new Date()).format('DDMMYYYYHHmmss');
      this.einvoice_data.apartment_code = this.item.invoice_data.apartment_code;
      this.einvoice_data.description = "Thu tiền " + this.item.service.service_name + " từ " +
        this.item.service.date_from + " đến " + this.item.service.date_to + " căn " +
        this.item.invoice_data.apartment_code;
      this.einvoice_data.measure = this.item.service.service_code == "POWER" ? "Kwh" : this.item.service.service_code == "WATER" ? "m³" : "";
      this.einvoice_data.quantity = this.item.service.last_value;
      this.einvoice_data.unit_price = this.item.service.price_unit;
      this.einvoice_data.vat = this.item.service.vat;
      this.einvoice_data.company = this.item.invoice_data_info.profile_company_name;
      this.einvoice_data.tax_code = this.item.invoice_data_info.profile_company_tax_code;
      this.einvoice_data.address = this.item.invoice_data_info.profile_company_address;
    },
    loadInfoEinvoiceBkav: function() {
      this.einvoice_data.bill_code = this.item.bill_code
      this.einvoice_data.description = this.item.description
      this.einvoice_data.apartment_code = this.item.apartment_code
      this.einvoice_data.measure = this.item.measure
      this.einvoice_data.quantity = this.item.quantity
      this.einvoice_data.unit_price = this.item.unit_price
      this.einvoice_data.vat = this.item.vat
      this.einvoice_data.record_date = this.item.record_date
      this.einvoice_data.buying_person = this.item.buying_person
      this.einvoice_data.company = this.item.company
      this.einvoice_data.tax_code = this.item.tax_code
      this.einvoice_data.address = this.item.address
      this.einvoice_data.account = this.item.account
      this.einvoice_data.method = this.item.method
      this.einvoice_data.invoice_code = this.item.invoice_code
      this.einvoice_data.email_receive = this.item.email_receive
      this.einvoice_data.dse_email = this.item.dse_email
      this.einvoice_data.sms_receive = this.item.sms_receive
      this.einvoice_data.dss_ms = this.item.dss_ms
      this.einvoice_data.print_receive = this.item.print_receive
      this.einvoice_data.name_receive_phone = this.item.name_receive_phone
      this.einvoice_data.house_no = this.item.house_no
      this.einvoice_data.city = this.item.city
      this.einvoice_data.district = this.item.district
      this.einvoice_data.commune = this.item.commune
      this.einvoice_data.other_details = this.item.other_details
      this.einvoice_data.is_create = this.item.is_create;
      this.einvoice_data.id = this.item.id;
      $("#modal-einvoice").modal("show");
    },
    updateEinvoiceBkav: function() {
        let einvoice_data = {
          "bill_code": this.einvoice_data.bill_code,
          "description": this.einvoice_data.description,
          "apartment_code":this.einvoice_data.apartment_code,
          "measure": this.einvoice_data.measure,
          "quantity": this.einvoice_data.quantity,
          "unit_price": this.einvoice_data.unit_price,
          "vat": this.einvoice_data.vat,
          "record_date": utils.formatSqlDate(this.einvoice_data.record_date, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
          "buying_person": this.einvoice_data.buying_person,
          "company": this.einvoice_data.company,
          "tax_code": this.einvoice_data.tax_code,
          "address": this.einvoice_data.address,
          "account": this.einvoice_data.account,
          "method": this.einvoice_data.method,
          "invoice_code": this.einvoice_data.invoice_code,
          "email_receive": this.einvoice_data.email_receive,
          "dse_email": this.einvoice_data.dse_email,
          "sms_receive": this.einvoice_data.sms_receive,
          "dss_ms": this.einvoice_data.dss_ms,
          "print_receive": this.einvoice_data.print_receive,
          "name_receive": this.einvoice_data.name_receive,
          "name_receive_phone": this.einvoice_data.name_receive_phone,
          "house_no": this.einvoice_data.house_no,
          "city": this.einvoice_data.city,
          "district": this.einvoice_data.district,
          "commune": this.einvoice_data.commune,
          "other_details": this.einvoice_data.other_details,
          "id":this.einvoice_data.id
        };

        if (this.item.is_create) {
          this.ADD_EINVOICE_BKAV(einvoice_data).then(
            function() {
              $("#modal-einvoice").modal("hide");
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
        } else {
          this.UPDATE_EINVOICE_BKAV(einvoice_data).then(
            function() {
              this.$emit('reload_einvoice_list');
              $("#modal-einvoice").modal("hide");
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
        }
      },
      ...mapActions([
        "SUCCESS_TOAST",
        "ON_SHOW_TOAST",
        "ERROR_TOAST",
        "ADD_EINVOICE_BKAV",
        "UPDATE_EINVOICE_BKAV"
      ])
  },
  mounted() {

  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker
  },
}
</script>
<style lang="scss" scoped>
  .mg-left {
      margin-left: 5px;
  }
  .hide-scroll-bar::-webkit-scrollbar {
      display: none;
  }
  .custom_modal {
    width: 1200px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/LTEModalEInvoiceBkav.vue